var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifesaver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M9.405 11.746C8.968 11.91 8.495 12 8 12c-.494 0-.968-.09-1.405-.254l-.702 1.873C6.548 13.865 7.258 14 8 14c.742 0 1.452-.135 2.107-.38l-.702-1.874Zm2.341-2.341 1.873.702C13.865 9.452 14 8.742 14 8c0-.742-.135-1.452-.38-2.107l-1.874.702c.164.437.254.91.254 1.405 0 .494-.09.968-.254 1.405ZM9.405 4.254l.702-1.873A5.987 5.987 0 0 0 8 2c-.742 0-1.452.135-2.107.38l.702 1.874C7.032 4.09 7.505 4 8 4c.494 0 .968.09 1.405.254ZM4.254 6.595 2.38 5.893A5.987 5.987 0 0 0 2 8c0 .742.135 1.452.38 2.107l1.874-.702A3.991 3.991 0 0 1 4 8c0-.494.09-.968.254-1.405ZM8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifesaver);
export default __webpack_public_path__ + "static/media/lifesaver.399be2e8a288548e734bb61dab6f8073.svg";
export { ForwardRef as ReactComponent };